/**
 * About Section Scroll Animations
 * Handles scroll-triggered animations, parallax effects, and micro-interactions
 */

(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Configuration
  const config = {
    rootMargin: '0px 0px -100px 0px', // Trigger 100px before element enters viewport
    threshold: 0.1,
    staggerDelay: 150, // ms between each element animation
  };

  /**
   * Initialize scroll animations using Intersection Observer
   */
  function initScrollAnimations() {
    if (prefersReducedMotion) {
      // If user prefers reduced motion, show all elements immediately
      document.querySelectorAll('.about-animate').forEach(el => {
        el.classList.add('about-animate--visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add visible class when element enters viewport
          entry.target.classList.add('about-animate--visible');

          // Optionally unobserve after animation (one-time animation)
          // observer.unobserve(entry.target);
        }
      });
    }, config);

    // Observe all animated elements
    document.querySelectorAll('.about-animate').forEach((el, index) => {
      // Add staggered delay based on element index
      el.style.transitionDelay = `${index * config.staggerDelay}ms`;
      observer.observe(el);
    });
  }

  /**
   * Initialize parallax effects for background elements
   */
  function initParallax() {
    if (prefersReducedMotion) return;

    const parallaxElements = document.querySelectorAll('.about-parallax');
    if (parallaxElements.length === 0) return;

    let ticking = false;

    function updateParallax() {
      parallaxElements.forEach(el => {
        const speed = parseFloat(el.dataset.parallaxSpeed) || 0.5;
        const rect = el.getBoundingClientRect();
        const scrolled = window.pageYOffset;
        const elementTop = rect.top + scrolled;
        const elementHeight = el.offsetHeight;
        const windowHeight = window.innerHeight;

        // Calculate parallax offset
        if (rect.top < windowHeight && rect.bottom > 0) {
          const offset = (scrolled - elementTop + windowHeight) * speed;
          el.style.transform = `translateY(${offset}px)`;
        }
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    // Use passive event listener for better scroll performance
    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial parallax positioning
    updateParallax();
  }

  /**
   * Add floating animation to decorative elements
   */
  function initFloatingElements() {
    if (prefersReducedMotion) return;

    const floatingElements = document.querySelectorAll('.about-floating');

    floatingElements.forEach((el, index) => {
      // Stagger the animation timing for more natural movement
      const delay = index * 0.5;
      el.style.animationDelay = `${delay}s`;
    });
  }

  /**
   * Enhanced hover effects for cards
   */
  function initCardEffects() {
    const cards = document.querySelectorAll('.about__section, .about__card');

    cards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        this.style.willChange = 'transform, box-shadow';
      });

      card.addEventListener('mouseleave', function() {
        this.style.willChange = 'auto';
      });
    });
  }

  /**
   * Add text reveal animation (optional - can be enabled later)
   */
  function initTextReveal() {
    if (prefersReducedMotion) return;

    const revealElements = document.querySelectorAll('.about-text-reveal');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('about-text-reveal--active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    revealElements.forEach(el => observer.observe(el));
  }

  /**
   * Initialize gradient animation on main title
   */
  function initGradientAnimation() {
    if (prefersReducedMotion) return;

    const title = document.querySelector('.about__title');
    if (title) {
      title.classList.add('about-gradient-animate');
    }
  }

  /**
   * Main initialization
   */
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Check if about section exists on page
    const aboutSection = document.querySelector('.about');
    if (!aboutSection) return;

    // Initialize all features
    initScrollAnimations();
    initParallax();
    initFloatingElements();
    initCardEffects();
    initGradientAnimation();
    // initTextReveal(); // Optional - uncomment to enable

    console.log('About section animations initialized');
  }

  // Start initialization
  init();

  /**
   * Expose public API for manual control if needed
   */
  window.AboutAnimations = {
    init: init,
    prefersReducedMotion: prefersReducedMotion
  };

})();
